import { html, Page } from 'rune-ts';

export interface SyncSigninPageData {
  redirect_url: string;
}

export class SyncSigninPage extends Page<SyncSigninPageData> {
  override template() {
    return html`<div></div>`;
  }
  override onRender() {
    location.replace(this.data.redirect_url);
  }
}
